import React from 'react';
import FooterLayout from '../FooterLayout'
import { useLocation } from 'react-router-dom';
import { usePermission } from '../../../hooks/usePermission';

function MasterListFooter({ createMasterEnabled, alterEnabled = true, deleteEnabled = true }) {
    const location = useLocation();
    let category = null;
    let pageName = null;

    switch (location.pathname) {
        case '/chart-of-account-accounting-master-group':
            category = 'Masters'; pageName = 'Groups'; break;
        case '/chart-of-account-accounting-master-ledger':
            category = 'Masters'; pageName = 'Ledgers'; break;
        case '/chart-of-account-accounting-master-voucherstype':
            category = 'Masters'; pageName = 'Voucher Types'; break;
        case '/chart-of-account-invmas-stockgroup':
            category = 'Masters'; pageName = 'Stock Groups'; break;
        case '/chart-of-account-invmas-stockcategory':
            category = 'Masters'; pageName = 'Stock Categories'; break;
        case '/chart-of-account-invmas-stockcompany':
            category = 'Masters'; pageName = 'Stock Company'; break;
        case '/chart-of-account-invmas-stockitem':
            category = 'Masters'; pageName = 'Stock Items'; break;
        case '/chart-of-account-invmas-unit':
            category = 'Masters'; pageName = 'Units'; break;
        case '/chart-of-account-invmas-godown':
            category = 'Masters'; pageName = 'Godowns'; break;
        default: break;
    }

    const { add, alter, view, delete: canDelete } = usePermission(category || '', pageName || '');

    const finalCreateEnabled = category ? (createMasterEnabled && add) : createMasterEnabled;
    const finalAlterEnabled = category ? (alterEnabled && alter) : alterEnabled;
    const finalViewEnabled = category ? view : true;
    const finalDeleteEnabled = category ? (deleteEnabled && canDelete) : deleteEnabled;

    const fields = [
        { id: "1", name: "Back", shortcutKey: "Esc", line: '', type: 'button', isDisabled: false },
        { id: "2", name: finalAlterEnabled ? "Alter" : "", shortcutKey: finalAlterEnabled ? "Enter" : "", line: finalAlterEnabled ? 'single' : '', type: 'button', isDisabled: !finalAlterEnabled },
        { id: "3", name: finalViewEnabled ? "View" : "", shortcutKey: finalViewEnabled ? "Enter" : "", line: '', type: 'button', isDisabled: !finalViewEnabled },
        { id: "4", name: "", shortcutKey: "", line: '', type: 'button', isDisabled: true, },
        { id: "5", name: finalCreateEnabled ? "Create Master" : "", shortcutKey: finalCreateEnabled ? "C" : "", line: finalCreateEnabled ? 'single' : '', type: 'button', isDisabled: !finalCreateEnabled },
        { id: "6", name: "", shortcutKey: "", line: '', type: 'button', isDisabled: true },
        { id: "7", name: finalDeleteEnabled ? "Delete" : "", shortcutKey: finalDeleteEnabled ? "D" : "", line: finalDeleteEnabled ? 'single' : '', type: 'button', isDisabled: !finalDeleteEnabled },
        { id: "8", name: "", shortcutKey: "", line: '', type: 'button', isDisabled: true },
        { id: "9", name: "Remove Line", shortcutKey: "R", line: 'double', type: 'button', isDisabled: true },
        { id: "10", name: "Restore Line", shortcutKey: "U", line: 'double', type: 'button', isDisabled: true },
    ]
    return (
        <div className='tomasterfooter'>
            <div className='footer'>
                {
                    fields.map((item, index) => {
                        return (
                            <FooterLayout key={item.id} fields={item} />
                        )
                    })
                }

            </div>
        </div>
    )
}

export default MasterListFooter
